/* ==========================================================
   WM Article Body — wm-article-body.js
   Version: 1.0.0
   ========================================================== */

(function () {
  'use strict';

  class WMArticleBody extends HTMLElement {
    connectedCallback() {
      this._init();
    }

    disconnectedCallback() {
      this._removeListeners();
    }

    _init() {
      this._overlay = this.querySelector('[data-lightbox-overlay]');
      this._lightboxImg = this.querySelector('[data-lightbox-image]');
      this._closeBtn = this.querySelector('[data-lightbox-close]');

      if (!this._overlay || !this._lightboxImg) return;

      this._onFigureClick = this._onFigureClick.bind(this);
      this._onClose = this._onClose.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onOverlayClick = this._onOverlayClick.bind(this);

      this.querySelectorAll('.wm-article-body__content img').forEach(function (img) {
        img.addEventListener('click', this._onFigureClick);
      }, this);

      if (this._closeBtn) {
        this._closeBtn.addEventListener('click', this._onClose);
      }

      this._overlay.addEventListener('click', this._onOverlayClick);
      document.addEventListener('keydown', this._onKeydown);
    }

    _removeListeners() {
      if (this._onFigureClick) {
        this.querySelectorAll('.wm-article-body__content img').forEach(function (img) {
          img.removeEventListener('click', this._onFigureClick);
        }, this);
      }

      if (this._closeBtn && this._onClose) {
        this._closeBtn.removeEventListener('click', this._onClose);
      }

      if (this._overlay && this._onOverlayClick) {
        this._overlay.removeEventListener('click', this._onOverlayClick);
      }

      document.removeEventListener('keydown', this._onKeydown);
    }

    _onFigureClick(e) {
      var img = e.currentTarget;
      this._lightboxImg.src = img.src;
      this._lightboxImg.alt = img.alt || '';
      this._overlay.classList.add('is-open');
      this._overlay.removeAttribute('aria-hidden');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      if (this._closeBtn) {
        this._closeBtn.focus();
      }
    }

    _onClose() {
      this._closeLightbox();
    }

    _onOverlayClick(e) {
      if (e.target === this._overlay) {
        this._closeLightbox();
      }
    }

    _onKeydown(e) {
      if (e.key === 'Escape' && this._overlay && this._overlay.classList.contains('is-open')) {
        this._closeLightbox();
      }
    }

    _closeLightbox() {
      if (!this._overlay) return;
      this._overlay.classList.remove('is-open');
      this._overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      this._lightboxImg.removeAttribute('src');
      this._lightboxImg.alt = '';
    }
  }

  if (!customElements.get('wm-article-body')) {
    customElements.define('wm-article-body', WMArticleBody);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.dataset.sectionType === 'wm-article-body') {
      var el = e.target.querySelector('wm-article-body');
      if (el) {
        el._removeListeners();
        el._init();
      }
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.dataset.sectionType === 'wm-article-body') {
      var el = e.target.querySelector('wm-article-body');
      if (el) el._removeListeners();
    }
  });
})();
